import api from "./api";

const BASE = "/support-tickets";

export const listMyTickets = () => api.get(BASE);
export const createTicket = (data) => api.post(BASE, data);
export const getTicket = (id) => api.get(`${BASE}/${id}`);
export const sendMessage = (id, data) => {
  if (data.attachment) {
    const fd = new FormData();
    if (data.message) fd.append("message", data.message);
    fd.append("attachment", data.attachment);
    if (data.isInternal) fd.append("isInternal", "true");
    return api.post(`${BASE}/${id}/messages`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return api.post(`${BASE}/${id}/messages`, data);
};
export const updateStatus = (id, status) => api.put(`${BASE}/${id}/status`, { status });
export const getMyCounts = () => api.get(`${BASE}/my-counts`);

// Admin
export const adminListTickets = (status) => api.get(`${BASE}/admin`, { params: { status } });
export const adminGetCounts = () => api.get(`${BASE}/admin/counts`);
